import { config } from "../AppConfig";

async function getLink(key, referralUserId) {
  const result = await fetch(`${config.url.API_BASE}/api/ajax/v1/links?key=${key}&r=${referralUserId}`, {
    method: "GET",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Credentials": true
    }
  });

  const json = await result.json();

  switch(result.status){
    case 200:
      return { data: json, error: null }
    case 400:
      return { data: null, error: json.details[0].details}
    default:
      return { data: null, error: "Unknown Error" }
  }
}

async function getReferralLink(key) {
  const result = await fetch(`${config.url.API_BASE}/api/ajax/v1/referral?key=${key}`, {
    method: "GET",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Credentials": true
    }
  });

  const json = await result.json();

  switch(result.status){
    case 200:
      return { data: json, error: null }
    case 400:
      return { data: null, error: json.details[0].details}
    default:
      return { data: null, error: "Unknown Error" }
  }
}


export const purchaseLinkService = {
  getLink,
  getReferralLink
}